<div *ngIf="impersonateService.data.impersonationEmails$ | async as details" class="impersonate-banner">
  <div></div>
  <span class="mat-hint">Support session opened by {{details.impersonator}}</span>
  <button mat-button (click)="endImpersonation()">End Support Session</button>
</div>
